import React from 'react';
import './OrderItemSummary.scss';
import { Divider, List } from 'antd';
import PurchaseItem from './PurchaseItem';
import DiscountItem from './DiscountItem';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { getIsMobile } from 'Store/Screen/selectors';



interface IProps {
  orderItems: Julius.Website.OrderItemViewModel[];
  discountItems: Julius.Website.VoucherViewModel[];
  totalPrice: number;
}

const OrderItemSummary: React.SFC<IProps> = ({
  orderItems,
  discountItems,
  totalPrice,
}) => {
  
  
  if (!orderItems || !orderItems.length) {
    return null;
  }
  return (
  
    <div className='order-item-summary'>
      <FormattedText 
        style='title black'
        displayName='Summering'
        formattedName='order.summary.header'
      />
      <div className='header-container'>
        <div className='header'>
          <FormattedText 
            style='type-header'
            displayName='Typ'
            formattedName='global.type'  
          />
          <FormattedText 
            style='seat-header'
            displayName='Platser'
            formattedName='global.seat'  
          />
          <FormattedText 
            style='quantity-header'
            displayName='Antal'
            formattedName='global.quantity'
          />
       
        </div>
        <Divider />
      </div>
      
      <OrderItems items ={ orderItems } />
      <DiscountItems items={ discountItems } />
      
      <div className='total-price bold'>
        <FormattedText
        displayName='Summa'
        formattedName='global.sum'
        />
        <PriceItem price={ totalPrice } decimals={ 2 } />
      </div>
      <Divider />
    
    </div>
  );
};


export const OrderItems: React.SFC<{ 
  items: Julius.Website.OrderItemViewModel[];
}> = ({ 
  items
}) => (
  items && items.length ?
    <>
      { items.map((item, key) => 
          <PurchaseItem
            key={ key }
            item={ item } 
          />)
      }
    </> : null
)

export const DiscountItems: React.SFC<{ 
  items: Julius.Website.VoucherViewModel[];
}> = ({ 
  items,
}) => (  
  items && items.length ?
    <>
      { items.map(v => 
        <DiscountItem 
          key={ v.code }
          code={ v.code }
          price={ v.price }
        />) 
      }
    </> : null
);

export default OrderItemSummary



// WEBPACK FOOTER //
// ./src/components/OrderItemSummary/OrderItemSummary.tsx